import { CommonDependency } from '@/dependency';
import { Group } from './types';
import { useEffect, useState } from 'react';

export const useAllGroupList = () => {
  const [groups, setGroups] = useState<Group[]>([]);
  const [isFetched, setFetched] = useState(false);

  useEffect(() => {
    if(CommonDependency.api.fetchAllGroupList){
      CommonDependency.api.fetchAllGroupList().then(res => {
        setFetched(true);
        setGroups(res.groups);
      });
    }
  }, []);

  return { data: groups, isFetched };
};
